module.exports = __webpack_public_path__ + "img/valance-trojan.7f516277.jpg";